import React, { useEffect, useState } from "react";
import { SlClose } from "react-icons/sl";
import { TbSteeringWheel } from "react-icons/tb";
import StopsComponent from "./StopsComponent";
import BookingSummaryComponent from "./BookingSummaryComponent";


const BusCardComponent = (props) => {

  const [showSeats, setshowSeats] = useState(false);
  const [booking, setbooking] = useState();
  const [newBookedarray, setnewBookedarray] = useState();
  const [showSummary, setshowSummary] = useState(false);
  const [selectedSeats, setselectedSeats] = useState([]);
  const [showStopComponent, setShowStopComponent] = useState(false);
  const [totalSeatsAvailable, settotalSeatsAvailable] = useState();
  const [titlePrice, settitlePrice] = useState()

  useEffect(() => {
    let arr = []
    let i, j;
    let totalseats = 0;
    let bookedSeats = 0;


    for (i = 0; i < props.busdata.lowerSeats.length; i++) {
      console.log(props.busdata.lowerSeats[i].length)
      totalseats = totalseats + props.busdata.lowerSeats[i].length;
      for (j = 0; j < props.busdata.lowerSeats[i].length; j++) {
        arr.push(props.busdata.lowerSeats[i][j].seatPrice)
        console.log(arr)

      }
      settitlePrice(arr.sort()[0])
    }
    for (i = 0; i < props.busdata.upperSeats.length; i++) {
      totalseats = totalseats + props.busdata.upperSeats[i].length;
      for (j = 0; j < props.busdata.lowerSeats[i].length; j++) {
        arr.push(props.busdata.lowerSeats[i][j].seatPrice)


      }

    }
    const bookingData = props.busBooking.filter(
      (booking) => booking.busId === props.busdata._id
    );
    for (i = 0; i < bookingData.length; i++) {
      bookedSeats = bookedSeats + bookingData[i].seats.length;


    }
    settotalSeatsAvailable(totalseats - bookedSeats)

  }, [])
  const handleCloseIcon = () => {
    setselectedSeats([]);
    props.clearBookingState();
    setshowSeats(false)

  }
  useEffect(() => {

    if (props.newBooking === null) {
      setShowStopComponent(false)
    }
    else {
      if (props?.newBooking?.bus_id !== props.busdata._id) {
        setShowStopComponent(false)
      }
      else {
        if (props.newBooking?.seats.length === 0) {
          setShowStopComponent(false)
        }
        else {
          setShowStopComponent(true)
        }
      }
    }
  }, [props.newBooking])



  const showSummaryHandler = (value) => {
    if (value) {

      if (
        props.newBooking.boardingPoint !== null &&
        props.newBooking.droppingPoint !== null
      ) {

        setshowSummary(value);
      }
    }
  };

  const handleSeatSelect = async (y) => {

    if (props?.newBooking?.bus_id === props.busdata._id) {
      console.log(props?.newBooking?.bus_id, props.busdata._id)
      console.log("1st")


      if (props?.newBooking?.seats.filter((x) => x.seatNumber === y.seatNumber).length !== 0) {

        console.log("2st")
        const newSeats = props?.newBooking?.seats.filter((x) => x.seatNumber !== y.seatNumber);
        console.log("newSeats", newSeats)
        props.removeSeats(newSeats);
      }
      else {
        console.log("3st")
        let newSeat = {
          seatNumber: y.seatNumber,
          seatType: y.seatType,
          seatPrice: y.seatPrice,
          _id: y._id,
          passengername: '',
          passengergender: '',
          passengerage: ''
        }
        console.log(newSeat)
        props.addSeatToArray(newSeat);

      }

    }
    else {
      console.log(props?.newBooking, props.busdata._id)
      console.log("4st")
      let newSeats = {
        seatNumber: y.seatNumber,
        seatType: y.seatType,
        seatPrice: y.seatPrice,
        _id: y._id,
        passengername: '',
        passengergender: '',
        passengerage: ''
      }
      props.addNewBooking(props.busdata._id, props.busdata.routeId, newSeats);

    }
  };
  useEffect(() => {

    const newArray = [];
    var i, j;


    const bookingData = props.busBooking?.filter(
      (booking) => booking.busId === props.busdata._id
    );

    setbooking(bookingData);
    for (i = 0; i < bookingData?.length; i++) {
      for (j = 0; j < bookingData[i]?.seats.length; j++) {
        newArray.push(bookingData[i]?.seats[j].seatNumber);

      }
    }

    setnewBookedarray(newArray);
  }, [props.newBooking?.seats]);

  const selectSeatButtonPressed = () => {
    setshowSeats(!showSeats);


  }

  return (
    <>
      <div className="ml-2 mr-2 lg:mr-0 lg:ml-16 border-2 lg:w-[85%] mt-7 rounded-lg shadow-lg">
        <div className="flex items-center justify-between p-2 lg:pl-5 lg:pr-5 lg:pt-5 lg:pb-5">
          <div className=" hidden lg:flex flex-col gap-2">
            <p className="font-semibold text-lg">{props.busdata.departureTime}</p>
            <p className="text-xs text-gray-400"></p>
            <p className="font-semibold text-lg">{props.busdata.arrivalTime}</p>
          </div>
          <div className="flex flex-col gap-2 ">
            <p className="text-lg font-semibold">{props.busdata.name}</p>
            <p className="text-xs text-gray-400">{props.busdata.busType}</p>
          </div>
          <p className="  hidden lg:block text-xs text-gray-400">{totalSeatsAvailable} Seats Available</p>
          <p className="text-lg font-semibold">Rs.{titlePrice}</p>
          <button
            onClick={() => selectSeatButtonPressed()}
            className="bg-[#FF6E1A] text-white px-1 lg:px-3 py-1 rounded-md"
          >
            Select Seat
          </button>
        </div>
        <div className="ml-2 mb-1 flex lg:hidden text-sm text-gray-400">
          <p className=" ">{props.busdata.departureTime} -</p>

          <p className="">{props.busdata.arrivalTime}</p>
        </div>
        {showSeats ? (
          <div className="bg-[#fff9c4] ">
            <div className="flex gap-3 px-8 py-5 items-center justify-between">
              <div className="flex gap-3">
                <span className=" bg-[#fff] px-2 py-1 text-xs">Seat Price</span>
                <span className="bg-[#fff] w-12 py-1  text-xs text-center">
                  ALL
                </span>
                <span className="bg-[#fff] w-12 py-1 text-xs text-center">
                  500
                </span>
                <span className="bg-[#fff] w-12 py-1 text-xs text-center">
                  1000
                </span>
              </div>
              <SlClose
                className="h-6 w-6 cursor-pointer"
                onClick={() => handleCloseIcon()}
              />
            </div>
            <hr />
            <div className="lg:flex justify-between px-8 pt-5 pb-5 ">
              <div className="bg-[#fff] p-2 px-4 flex flex-col rounded-lg">

                <div className="text-center font-semibold">Lower Seats</div>
                <TbSteeringWheel className="w-5 h-5 ml-auto mr-4" />
                <div className="  flex gap-3 px-2 py-3 ">


                  {props.busdata.lowerSeats.map((x) => (
                    <div className="flex flex-col gap-4">
                      {x.map((y) => {
                        return newBookedarray?.includes(y.seatNumber) ? (
                          <div className="py-1 border bg-[#e1f5fe]   text-xs w-[5rem] flex-col flex justify-center items-center gap-1 ">
                            <p>{y.seatType}</p>
                            <p className="font-bold">{y.seatNumber}</p>
                            <p className="font-bold">{y.seatPrice}</p>
                          </div>
                        ) : (

                          <div
                            onClick={() => handleSeatSelect(y)}
                            className={props?.newBooking === null ? "py-1 border   border-gray-700  cursor-pointer text-xs w-[5rem] flex-col flex justify-center items-center gap-1 "
                              : props?.newBooking?.seats.filter((x) => x.seatNumber === y.seatNumber).length !== 0 && props?.newBooking?.bus_id === props.busdata._id
                                ? "py-1 border bg-[#00b0ff]   border-gray-700  cursor-pointer text-xs w-[5rem] flex-col flex justify-center items-center gap-1 " : "py-1 border   border-gray-700  cursor-pointer text-xs w-[5rem] flex-col flex justify-center items-center gap-1 "}


                          >
                            <p>{y.seatType}</p>
                            <p className="font-bold">{y.seatNumber}</p>
                            <p className="font-bold">{y.seatPrice}</p>
                          </div>


                        );
                      })}
                    </div>
                  ))}


                </div>

              </div>
              <div className="bg-[#fff] p-2 px-4  flex flex-col rounded-lg ">
                <div className="text-center font-semibold">Upper Seats</div>
                <TbSteeringWheel className="w-5 h-5 ml-auto mr-4" />
                <div className="flex gap-3 px-2 py-3 ">


                  {props.busdata.upperSeats.map((x) => (
                    <div className="flex flex-col gap-4">
                      {x.map((y) => {
                        return newBookedarray?.includes(y.seatNumber) ? (
                          <div className="py-1 border bg-[#e1f5fe]   text-xs w-[5rem] flex-col flex justify-center items-center gap-1 ">
                            <p>{y.seatType}</p>
                            <p className="font-bold">{y.seatNumber}</p>
                            <p className="font-bold">{y.seatPrice}</p>
                          </div>
                        ) : (
                          <div
                            onClick={() => handleSeatSelect(y)}
                            className={props?.newBooking === null ? "py-1 border   border-gray-700  cursor-pointer text-xs w-[5rem] flex-col flex justify-center items-center gap-1 "
                              : props?.newBooking?.seats.filter((x) => x.seatNumber === y.seatNumber).length !== 0 && props?.newBooking?.bus_id === props.busdata._id
                                ? "py-1 border bg-[#00b0ff]   border-gray-700  cursor-pointer text-xs w-[5rem] flex-col flex justify-center items-center gap-1 " : "py-1 border   border-gray-700  cursor-pointer text-xs w-[5rem] flex-col flex justify-center items-center gap-1 "}


                          >
                            <p>{y.seatType}</p>
                            <p className="font-bold">{y.seatNumber}</p>
                            <p className="font-bold">{y.seatPrice}</p>
                          </div>

                        );
                      })}
                    </div>
                  ))}


                </div>
              </div>
              {!showStopComponent ? (
                <div className="w-[25%]">
                  <p className="font-semibold mb-4">SEAT LEGEND</p>
                  <div className="flex gap-5 flex-wrap">
                    <div className="flex items-center gap-1 ">
                      <div className="w-10 h-4 bg-white border border-gray-700"></div>
                      <p className="text-xs">Available</p>
                    </div>
                    <div className="flex items-center gap-1 ">
                      <div className="w-10 h-4 bg-[#e1f5fe] border border-gray-700"></div>
                      <p className="text-xs">Unavailable</p>
                    </div>

                  </div>
                </div>
              ) : !showSummary ? (
                <StopsComponent
                  seatsClicked={props.newBooking?.seats}
                  showSummaryFunction={(value) => showSummaryHandler(value)}
                  addBoardingPoint={props.addBoardingPoint}
                  addDroppingPoint={props.addDroppingPoint}
                  boardingPoint={props.busdata.boardingPoint}
                  droppingPoint={props.busdata.droppingPoint}
                  newBooking={props.newBooking}
                />
              ) : (
                <BookingSummaryComponent updateSeatWithPerson={props.updateSeatWithPerson} addContactDetails={props.addContactDetails} onClick={(value) => setshowSummary(value)} userid={props.userid} journeyDetails={props.journeyDetails} newBooking={props.newBooking} />
              )}
            </div>
          </div>
        ) : (
          <></>
        )}
      </div >
    </>
  );
};

export default BusCardComponent;
